import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IUnitPlanModel } from '@apps-common/types/portal/unit'

export const updateUnitPlan = async (model: IUnitPlanModel): Promise<IUnitPlanModel> =>
  axios.post(`/management/unitplan/updateunitplan`, model).then((res) => res?.data?.data)

type Props = {
  model: IUnitPlanModel
}

export const useManagementUpdateUnitPlan = (notify?: boolean, onSuccess?: (data: IUnitPlanModel) => void) =>
  useMutation({
    mutationKey: ['updateUnitPlan'],
    mutationFn: ({ model }: Props) => updateUnitPlan(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Updated device plan.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to update device plan, please try again.')
      }
    },
    throwOnError: false
  })
